
import { Component, PropSync, Mixins } from 'vue-property-decorator';
import { historyTableColumns } from '@/features/common/raw';
import { setTableColumns } from '@/features/shipment-history/services/shipment-history.services';
import { showErrorAlertDialog } from '@/features/common/helpers';
import focusMixin from '@/features/common/mixins/focusMixin';
import { Drag, DropList } from 'vue-easy-dnd';

@Component({
  components: {
    DropList,
    Drag,
  },
})
export default class HistoryOrderModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  private defaultTableColumns: string[] = [...historyTableColumns];

  private tableColumnsClone: string[] = [...this.tableColumns];

  private tableColumnsForToggle: string[] = [];

  private isLoading = false;

  get tableColumns(): string[] {
    return this.$store.getters.getHistoryTableColumns;
  }

  get allColumnsHidden(): boolean {
    return this.tableColumnsClone.length === 0;
  }

  private mounted(): void {
    this.createTableColumnsForToggle();
  }

  private createTableColumnsForToggle() {
    this.tableColumnsForToggle = this.defaultTableColumns.filter((col) => col !== 'Created');
  }

  private getColumnVisibility(name: string): boolean {
    return this.tableColumnsClone.includes(name);
  }

  private toggleColumn(name: string, show: boolean): void {
    if (show) {
      this.tableColumnsClone.push(name);
    } else {
      const idx = this.tableColumnsClone.indexOf(name);
      this.tableColumnsClone.splice(idx, 1);

      if (name === 'LastScan' && this.getColumnVisibility('ShipStatus')) {
        this.tableColumnsClone = this.tableColumnsClone.filter((col) => col !== 'ShipStatus');
        const createdIdx = this.tableColumnsClone.findIndex((col) => col === 'Created');

        this.tableColumnsClone = [
          ...this.tableColumnsClone.slice(0, createdIdx),
          'ShipStatus',
          ...this.tableColumnsClone.slice(createdIdx),
        ];
      }
    }
  }

  private getColumnForDragTitle(column): string {
    return this.$t(`history.tables.${column}`) as string;
  }

  private async apply(): Promise<void> {
    this.isLoading = true;
    const res = await setTableColumns(this.tableColumnsClone);

    if (!res) {
      showErrorAlertDialog();
    } else {
      this.$store.commit('setHistoryTableColumns', [...this.tableColumnsClone]);
    }

    this.isLoading = false;
    this.closeModal();
  }

  private reset(): void {
    this.tableColumnsClone = [...this.defaultTableColumns];
    this.createTableColumnsForToggle();
  }

  private closeModal(): void {
    this.syncedShow = false;
    this.tableColumnsClone = [...this.tableColumns];
  }
}
